import './faq.scss';
import {useQueryFAQ} from "../../api/faq/useQueryFAQ";
import Loading from '../../components/UI/Loading/Loading';
import ExpandableText from "../../components/UI/ExpandableText/ExpandableText";
import { useContext, useEffect } from 'react';
import { UserContext } from '../../hooks/Context/UserContext';

const FAQ = () => {
  const [user] = useContext(UserContext);

  const { data, isLoading } = useQueryFAQ({userId: user?.id});

  if (isLoading) {
    return <Loading loading/>
  }

  return <div className={'faq'}>
    <div className={'faq-title'}>
      Frequently asked questions
    </div>

    {data.map((item: any) =>
      <div>
        <div className={'faq-heading'}>
          <div className={'faq-heading-title'}>
            {item.heading}
          </div>
          {item.sections.map((section: any) =>
            <ExpandableText
              title={section.sub_heading}
              expandableHtml={section.content}
            />
          )}
        </div>
      </div>
    )}
  </div>
}

export default FAQ;